import { ModalOptions } from 'ngx-bootstrap/modal/modal-options.class';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { UnsubscriberBase } from '@core/services/unsubscriber.base';
import { IBaseModalComponent } from './i-base.modal-component';
import { mergeMap, takeUntil } from 'rxjs/operators';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ComponentType } from '@angular/cdk/overlay';
import { of, Subject } from 'rxjs';

export class BaseModalController extends UnsubscriberBase {
	protected _componentInstance: IBaseModalComponent;
	protected _modalHide$ = new Subject<void>();
	protected _modalReference: BsModalRef;

	constructor(private modal: BsModalService) {
		super();
	}

	protected closeModal(): void {
		if (this._modalReference) {
			this._modalReference.hide();
		}
	}

	protected launch<T extends IBaseModalComponent, F, Options>(
		modalComponent: ComponentType<F>,
		config?: ModalOptions<F>,
	): void {
		if (this._modalReference) {
			return;
		}
		this._modalReference = this.modal.show(modalComponent, config);
		this._componentInstance = this._modalReference.content as T;
		this._componentInstance.setOnHide(this.closeModal.bind(this));
		this.modal.onHide
			.pipe(
				takeUntil(this._modalHide$),
				mergeMap((hideReason: string) => {
					if (hideReason === 'backdrop-click' || hideReason === 'esc') {
						return this._componentInstance.onBackdropClick();
					}
					return of(hideReason);
				}),
			)
			.subscribe(() => {
				this._modalReference = null;
				this._modalHide$.next();
			});
	}
}
